var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$parent.isLoading || !_vm.$parent.isReady)?_c('div',[_c('img',{attrs:{"src":"/resources/loader.svg"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }